/* eslint-disable eol-last */
/* eslint-disable eqeqeq */
/* eslint-disable indent */
/* eslint-disable camelcase */
export {
    // eslint-disable-next-line no-use-before-define
    contents,
    // eslint-disable-next-line no-use-before-define
    reverseIndex
}

const contents = [{
    name: '文前信息',
    nameEN: 'Before Reading',
    parIndex: [1, 0, 0, 1],
    chapter: [{
        name: '文前',
        nameEN: 'Before reading',
        chpIndex: [1, 1, 0, 1],
        section: [{
            name: '封面',
            nameEN: 'Cover',
            secIndex: [1, 1, 1, 1]
        }, {
            name: '扉页',
            nameEN: 'Title page',
            secIndex: [1, 1, 2, 2]
        }, {
            name: '编纂委员会',
            nameEN: 'EDITORIAL COMMITTEE',
            secIndex: [1, 1, 3, 3]
        }, {
            name: '序一',
            nameEN: 'FOREWORD I',
            secIndex: [1, 1, 4, 4]
        }, {
            name: '序二',
            nameEN: 'FOREWORD II',
            secIndex: [1, 1, 5, 5]
        }, {
            name: '前言',
            nameEN: 'PREFACE',
            secIndex: [1, 1, 6, 7]
        }, {
            name: '编制说明',
            nameEN: 'GENERAL EXPLANATION',
            secIndex: [1, 1, 7, 8]
        }, {
            name: '历史的继承与发展',
            nameEN: 'Milestones of tropical cyclone warning service and data compilation in Shanghai, 1872-present',
            secIndex: [1, 1, 8, 11]
        }]
    }, {
        name: '目录',
        nameEN: 'Contents',
        chpIndex: [1, 2, 0, 12],
        section: []
    }]
}, {
    name: '热带气旋的发生、发展和消亡',
    nameEN: 'Genesis, Development and Dissipation of Tropical Cyclones',
    parIndex: [2, 0, 0, 1],
    chapter: [{
        name: '热带气旋的生命史',
        nameEN: 'Lifespan',
        chpIndex: [2, 3, 0, 2],
        section: [{
            name: '热带气旋生命史',
            nameEN: 'Lifespan of tropical cyclones',
            secIndex: [2, 3, 9, 2]
        }, {
            name: '热带气旋的生成、变性和消亡 (1~12月)',
            nameEN: 'Locations of tropical cyclone genesis, extratropical transition, and dissipation (Jan.-Dec.)',
            secIndex: [2, 3, 10, 3]
        }, {
            name: '西北太平洋和南海海域热带气旋出现的年日数',
            nameEN: 'Annual days with tropical cyclones over the western North Pacific and South China Sea',
            secIndex: [2, 3, 11, 5]
        }, {
            name: '西北太平洋和南海海域热带气旋的逐月日数',
            nameEN: 'Monthly days with tropical cyclones over the western North Pacific and South China Sea',
            secIndex: [2, 3, 12, 5]
        }]
    }, {
        name: '热带气旋的频数',
        nameEN: 'Frequency',
        chpIndex: [2, 4, 0, 6],
        section: [{
            name: '西北太平洋热带气旋年频数',
            nameEN: 'Annual counts of tropical cyclones over the western North Pacific',
            secIndex: [2, 4, 13, 6]
        }, {
            name: '南海热带气旋年频数',
            nameEN: 'Annual counts of tropical cyclones over the South China Sea',
            secIndex: [2, 4, 14, 6]
        }, {
            name: '热带气旋月频数和日频数',
            nameEN: 'Monthly and daily counts of tropical cyclones (1981-2010) ',
            secIndex: [2, 4, 15, 6]
        }]
    }, {
        name: '热带气旋的强度',
        nameEN: 'Intensity',
        chpIndex: [2, 5, 0, 7],
        section: [{
            name: '累积气旋能量指数',
            nameEN: 'Accumulated cyclone energy (ACE)',
            secIndex: [2, 5, 16, 7]
        }, {
            name: '各等级热带气旋出现的比例分布',
            nameEN: 'Distribution of percentage of tropical cyclones in each intensity category',
            secIndex: [2, 5, 17, 9]
        }, {
            name: '各等级热带气旋出现的比例',
            nameEN: 'Percentage of tropical cyclones in each intensity category',
            secIndex: [2, 5, 18, 9]
        }, {
            name: '热带气旋强度的频率分布',
            nameEN: 'Probability distribution of tropical cyclone intensity',
            secIndex: [2, 5, 19, 10]
        }]
    }, {
        name: '热带气旋强度的变化',
        nameEN: 'Intensity Change',
        chpIndex: [2, 6, 0, 10],
        section: [{
            name: '热带气旋强度变化的频率分布',
            nameEN: 'Probability distribution of tropical cyclone intensity change',
            secIndex: [2, 6, 20, 10]
        }, {
            name: '热带气旋强度的变化',
            nameEN: 'Tropical cyclone intensity change',
            secIndex: [2, 6, 21, 11]
        }]
    }, {
        name: '双热带气旋和多热带气旋',
        nameEN: 'Binary and Multiple Tropical Cyclones',
        chpIndex: [2, 7, 0, 14],
        section: [{
            name: '双热带气旋和多热带气旋过程的频数',
            nameEN: 'Frequency of binary and multiple tropical cyclones',
            secIndex: [2, 7, 22, 14]
        }, {
            name: '双热带气旋和多热带气旋出现的时段',
            nameEN: 'Duration of binary and multiple tropical cyclones',
            secIndex: [2, 7, 23, 14]
        }, {
            name: '双热带气旋和多热带气旋过程期间的频次',
            nameEN: 'Tropical cyclones occurrence frequency during periods with binary and multiple tropical cyclones',
            secIndex: [2, 7, 24, 16]
        }]
    }]
}, {
    name: '热带气旋的路径和移动',
    nameEN: 'Tracks and Propagation of Tropical Cyclones',
    parIndex: [3, 0, 0, 1],
    chapter: [{
        name: '热带气旋的频次',
        nameEN: 'Occurrence Frequency',
        chpIndex: [3, 8, 0, 1],
        section: [{
            name: '热带气旋的频次',
            nameEN: 'Tropical cyclone occurrence frequency',
            secIndex: [3, 8, 25, 2]
        }, {
            name: '热带气旋的逐月频次',
            nameEN: 'Monthly tropical cyclone occurrence frequency',
            secIndex: [3, 8, 26, 4]
        }]
    }, {
        name: '热带气旋移向和移速',
        nameEN: 'Direction and Speed of Propagation',
        chpIndex: [3, 9, 0, 7],
        section: [{
            name: '移向的频率分布和各方位平均移速',
            nameEN: 'Probability distribution and mean speeds of different propagation directions',
            secIndex: [3, 9, 27, 7]
        }, {
            name: '逐月移向频率分布和各方位平均移速',
            nameEN: 'Monthly probability distribution and mean speeds of different propagation directions',
            secIndex: [3, 9, 28, 8]
        }, {
            name: '移向的频率分布',
            nameEN: 'Probability distribution of tropical cyclone propagation direction',
            secIndex: [3, 9, 29, 15]
        }, {
            name: '移速的频率分布',
            nameEN: 'Probability distribution of tropical cyclone propagation speed',
            secIndex: [3, 9, 30, 16]
        }]
    }, {
        name: '热带气旋转向',
        nameEN: 'Recurvature',
        chpIndex: [3, 10, 0, 18],
        section: [{
            name: '热带气旋转向点的分布',
            nameEN: 'Distribution of tropical cyclone recurving locations',
            secIndex: [3, 10, 31, 18]
        }, {
            name: '热带气旋转向前后的平均移速和强度',
            nameEN: 'Mean propagation speed and intensity before and after tropical cyclone recurvature',
            secIndex: [3, 10, 32, 19]
        }]
    }, {
        name: '热带气旋移动的变化',
        nameEN: 'Changes in Propagation',
        chpIndex: [3, 11, 0, 27],
        section: [{
            name: '热带气旋移动的变化',
            nameEN: 'Changes in propagation',
            secIndex: [3, 11, 33, 27]
        }]
    }, {
        name: '热带气旋的异常路径',
        nameEN: 'Abnormal Tracks',
        chpIndex: [3, 12, 0, 0],
        section: [{
            name: '热带气旋异常路径出现的频次',
            nameEN: 'Occurrence frequency of abnormal tracks',
            secIndex: [3, 12, 34, 30]
        }]
    }]
}, {
    name: '影响和登陆中国的热带气旋',
    nameEN: 'Tropical Cyclones Affecting and Landfalling in China',
    parIndex: [4, 0, 0, 1],
    chapter: [{
        name: '中国近海热带气旋活动',
        nameEN: 'Tropical cyclones near coastal China',
        chpIndex: [4, 13, 0, 1],
        section: [{
            name: '中国近海热带气旋活动的频数',
            nameEN: 'Frequency of tropical cyclones near coastal China',
            secIndex: [4, 13, 35, 2]
        }, {
            name: '中国近海热带气旋强度变化的频率分布',
            nameEN: 'Probability distribution of intensity changes for tropical cyclones near coastal China',
            secIndex: [4, 13, 36, 4]
        }, {
            name: '中国近海热带气旋的移动',
            nameEN: 'Tropical cyclone propagation near coastal China',
            secIndex: [4, 13, 37, 5]
        }]
    }, {
        name: '影响中国的热带气旋',
        nameEN: 'Tropical Cyclones Affecting China',
        chpIndex: [4, 14, 0, 6],
        section: [{
            name: '热带气旋影响中国期间的生命史',
            nameEN: 'Lifespan stages of tropical cyclones affecting China',
            secIndex: [4, 14, 38, 6]
        }, {
            name: '热带气旋影响中国的频数',
            nameEN: 'Frequency of tropical cyclones affecting China',
            secIndex: [4, 14, 39, 7]
        }, {
            name: '热带气旋影响中国的季节',
            nameEN: 'Seasonality of tropical cyclones affecting China',
            secIndex: [4, 14, 40, 12]
        }, {
            name: '热带气旋影响中国的年日数',
            nameEN: 'Annual days of tropical cyclones affecting China',
            secIndex: [4, 14, 41, 13]
        }, {
            name: '热带气旋影响中国的月日数',
            nameEN: 'Monthly days of tropical cyclones affecting China',
            secIndex: [4, 14, 42, 15]
        }, {
            name: '影响中国热带气旋的源地',
            nameEN: 'Genesis locations of tropical cyclones affecting China',
            secIndex: [4, 14, 43, 17]
        }, {
            name: '影响中国热带气旋的路径',
            nameEN: 'Tracks of tropical cyclones affecting China',
            secIndex: [4, 14, 44, 18]
        }, {
            name: '影响中国热带气旋的强度',
            nameEN: 'Intensities of tropical cyclones affecting China',
            secIndex: [4, 14, 45, 20]
        }]
    }, {
        name: '热带气旋影响中国导致的大风',
        nameEN: 'Severe Winds Generated by Tropical Cyclones in China',
        chpIndex: [4, 15, 0, 21],
        section: [{
            name: '导致中国陆域出现大风的热带气旋频数',
            nameEN: 'Counts of tropical cyclones generating severe wind over the land area of China',
            secIndex: [4, 15, 46, 21]
        }, {
            name: '热带气旋导致中国出现大风的极值分布',
            nameEN: 'Extreme winds generated by tropical cyclones in China',
            secIndex: [4, 15, 47, 24]
        }]
    }, {
        name: '热带气旋影响中国导致的降水',
        nameEN: 'Precipitation Generated by Tropical Cyclones in China',
        chpIndex: [4, 16, 0, 25],
        section: [{
            name: '热带气旋暴雨的频次',
            nameEN: 'Frequency of torrential rain generated by tropical cyclones',
            secIndex: [4, 16, 48, 25]
        }, {
            name: '热带气旋暴雨的月频次',
            nameEN: 'Monthly frequency of torrential rain generated by tropical cyclones',
            secIndex: [4, 16, 49, 26]
        }, {
            name: '热带气旋导致中国陆域出现降水时的位置',
            nameEN: 'Locations of tropical cyclones when generating precipitation over the land area of China',
            secIndex: [4, 16, 50, 34]
        }]
    }, {
        name: '登陆中国的热带气旋',
        nameEN: 'Tropical Cyclones Landfalling in China',
        chpIndex: [4, 17, 0, 0],
        section: [{
            name: '登陆中国热带气旋的频数',
            nameEN: 'Counts of tropical cyclones landfalling in China',
            secIndex: [4, 17, 51, 36]
        }, {
            name: '热带气旋登陆中国的季节',
            nameEN: 'Seasonality of tropical cyclones landfalling in China',
            secIndex: [4, 17, 52, 37]
        }, {
            name: '登陆中国热带气旋的源地',
            nameEN: 'Genesis locations of tropical cyclones landfalling in China',
            secIndex: [4, 17, 53, 38]
        }, {
            name: '登陆中国热带气旋的路径和移动',
            nameEN: 'Tracks and propagation of tropical cyclones landfalling in China',
            secIndex: [4, 17, 54, 39]
        }, {
            name: '登陆中国热带气旋的强度',
            nameEN: 'Intensity of tropical cyclones landfalling in China',
            secIndex: [4, 17, 55, 42]
        }]
    }]
}, {
    name: '热带气旋统计表',
    nameEN: 'Lists of Tropical Cyclones',
    parIndex: [5, 0, 0, 1],
    chapter: [{
        name: '热带气旋名录',
        nameEN: 'List of Tropical Cyclones',
        chpIndex: [5, 18, 0, 1],
        section: []
    }, {
        name: '因灾被除名的热带气旋',
        nameEN: 'Tropical Cyclones with Names Retired Due to Severe Damage',
        chpIndex: [5, 19, 0, 7],
        section: []
    }, {
        name: '双热带气旋和多热带气旋名录',
        nameEN: 'List of Binary and Multiple Tropical Cyclones',
        chpIndex: [5, 20, 0, 8],
        section: []
    }, {
        name: '影响和登陆中国的热带气旋',
        nameEN: 'Tropical Cyclones Affecting or Landfalling in China',
        chpIndex: [5, 21, 0, 9],
        section: [{
            name: '影响和登陆中国的热带气旋',
            nameEN: 'Tropical cyclones affecting or landfalling in China',
            secIndex: [5, 21, 56, 9]
        }, {
            name: '对中国影响居前50位的热带气旋',
            nameEN: 'Top 50 tropical cyclones affecting China',
            secIndex: [5, 21, 57, 10]
        }, {
            name: '登陆中国时强度居前 20 位的热带气旋',
            nameEN: 'Top 20 tropical cyclones according to their intensity when landfalling ',
            secIndex: [5, 21, 58, 11]
        }, {
            name: '1981~2010 年间最早和最晚登陆中国的热带气旋',
            nameEN: 'Earlist and latest tropical cyclones landfalling in China between 1981 and 2010 ',
            secIndex: [5, 21, 59, 11]
        }, {
            name: '热带气旋登陆中国时的强度极值',
            nameEN: 'Extreme intensity of tropical cyclones when landfalling',
            secIndex: [5, 21, 60, 11]
        }, {
            name: '热带气旋登陆中国前后的强度和移速',
            nameEN: 'Tropical cyclones intensity and propagation speed before and after landfall in China',
            secIndex: [5, 21, 61, 11]
        }, {
            name: '1981~2010 年期间在中国造成重大灾害的热带气旋',
            nameEN: 'Tropical cyclones causing severe damages in China between 1981 and 2010 ',
            secIndex: [5, 21, 62, 14]
        }]
    }]
}, {
    name: '附录',
    nameEN: 'Appendixes',
    parIndex: [6, 0, 0, 1],
    chapter: [{
        name: '扩展的蒲福风力等级表',
        nameEN: 'Extended Beaufort Wind Scale',
        chpIndex: [6, 22, 0, 1],
        section: []
    }, {
        name: '观测站分布',
        nameEN: 'Distribution of Weather Stations',
        chpIndex: [6, 23, 0, 2],
        section: []
    }]
}]

var reverseIndex = {}
createReverseIndex(contents)

// eslint-disable-next-line space-before-function-paren
function createReverseIndex(contents) {
    var par_chp = [] // 篇对应的章起始
    var chp_sec = [] // 章对应的节起始
    var chp_par = [] // 章对应的篇
    var sec_chp = [] // 节对应的章
    var sec_par = [] // 节对应的篇
    var parCounts = contents.length
    var chpCounts = 1
    var secCounts = 1
    for (let i = 0; i < parCounts; i++) {
        par_chp[i] = chpCounts
        var chpC = contents[i].chapter.length
        for (let j = 0; j < chpC; j++) {
            chp_sec[chpCounts + j - 1] = secCounts
            var secC = contents[i].chapter[j].section.length
            for (let k = 0; k < secC; k++) {
                sec_chp[secCounts + k - 1] = contents[i].chapter[j].section[k].secIndex[1]
                sec_par[secCounts + k - 1] = contents[i].chapter[j].section[k].secIndex[0]
            }
            secCounts = secCounts + secC
            chp_par[chpCounts + j - 1] = i + 1
        }
        chpCounts = chpCounts + chpC
    }
    reverseIndex = {
        parchp: par_chp,
        chpsec: chp_sec,
        chppar: chp_par,
        secchp: sec_chp,
        secpar: sec_par
    }
    return reverseIndex
}